import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    confirmPanelTitle: translate({
      id: 'gps.geofences.view.delete.title',
      values: { selected: 1 },
    }),
    title: (name?: string) => name ?? translate({ id: 'setup.routing.view.unnamedSegment' }),
    confirmPanelSubtitle: translate({ id: 'gps.geofences.view.delete.subtitle' }),
    delete: translate({ id: 'global.delete' }),
    edit: translate({ id: 'global.edit' }),
  }))

  return api
}
